/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".language-form[_ngcontent-%COMP%]{font:initial;width:40px}.mat-form-field[_ngcontent-%COMP%]{width:100%}.mat-form-field[_ngcontent-%COMP%], .mat-option[_ngcontent-%COMP%]{text-transform:capitalize}"];
export { styles as styles };
